//lib
import React from "react";
//src
import { TotalHeaderStyled } from "./total-header.style";
import { Button } from "../../../../components/button/button";
import {
  EnlargeIcon,
  EncircledPlusIcon,
} from "../../../../utils/svg-components";
import { Typography } from "@mui/material";
import { formatNumber } from "../../../../utils/utils";

const TotalHeader = ({
  total,
  projectData,
  rightContent,
  hideForMaterials,
}) => {
  const totalExists = total !== 0;
  const formattedValue = totalExists ? `$ ${formatNumber(total)}` : "$ 0.00";

  return (
    <TotalHeaderStyled>
      <div className="flex-24">
        <span>
          <Typography variant={"body3"}>Project Total</Typography>
          <Typography variant={"h5"}>{formattedValue}</Typography>
        </span>
        {hideForMaterials && (
          <span>
            <Typography variant={"body3"}>Plan Start Date</Typography>
            <Typography
              variant={"h5"}
              sx={{
                color: projectData.plannerStartDate
                  ? "inherit"
                  : "rgba(0, 0, 0, 0.38)",
              }}
            >
              {projectData.plannerStartDate || "mm/dd/yyyy"}
            </Typography>
          </span>
        )}
        {hideForMaterials && (
          <span>
            <Typography variant={"body3"}>Plan End Date</Typography>
            <Typography
              variant={"h5"}
              sx={{
                color: projectData.plannerEndDate
                  ? "inherit"
                  : "rgba(0, 0, 0, 0.38)",
              }}
            >
              {projectData.plannerEndDate || "mm/dd/yyyy"}
            </Typography>
          </span>
        )}
      </div>

      <div>{rightContent && rightContent}</div>
    </TotalHeaderStyled>
  );
};

export default TotalHeader;
